import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationHostTypeService } from '../../../../lib/services/application-host-type.service';
import { ReferenceDataService } from '../../../../lib/services/reference-data.service';
import { TabNavigationService } from '../../../mortgage-application/services/tab-navigation.service';
import { BaseSectionNavigationComponent } from '../../../shared/components/base-section-navigation.component';

const KfiPages = {
  KFI_YOUR_MORTGAGE: 'kfiYourMortgage',
  APPLICANTS: 'kfiApplicants'
};

@Component({
  selector: 'boi-kfi-section-navigation',
  template: ` <div #container><ng-content></ng-content></div> `
})
export class KfiSectionNavigationComponent extends BaseSectionNavigationComponent {
  constructor(
    protected tabNavigationService: TabNavigationService,
    public router: Router,
    protected referenceDataService: ReferenceDataService,
    protected readonly applicationHostTypeService: ApplicationHostTypeService
  ) {
    super(tabNavigationService, router, referenceDataService, applicationHostTypeService);
  }

  protected getNextTabRoute(): Array<string> {
    let routeItem = decodeURIComponent(this.router.url).split('/');
    let pageIndex = 3;

    const interfaceTypeCode = this.applicationHostTypeService.getCode()
      ? this.applicationHostTypeService.getCode().toLowerCase()
      : undefined;
    if (routeItem[1].toLowerCase() === interfaceTypeCode) {
      pageIndex++;
    }
    switch (routeItem[pageIndex]) {
      case KfiPages.KFI_YOUR_MORTGAGE:
        routeItem[pageIndex] = KfiPages.APPLICANTS;
        break;
      default:
        routeItem = [];
    }

    return routeItem;
  }
}
